/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StepCounts } from "./StepCounts";

/**
 * One step of an automation, with its words and its counts.
 */
export type StepResponse = {
  id: number;
  action: StepResponse.action;
  label: string;
  stage: number;
  offset_minutes: number;
  position: string;
  words: string;
  ask_first: boolean;
  approver_roles: StepResponse.approver_roles;
  template_id?: number | null;
  template_name?: string | null;
  send_to?: Array<"students" | "parents" | "tutors" | "admins">;
  sms?: boolean;
  email?: boolean;
  config?: any;
  counts: StepCounts;
  enabled_at?: string | null;
  last_run_at?: string | null;
  last_error?: string | null;
};

export namespace StepResponse {
  export enum action {
    SEND = "send",
    TASK = "task",
    CRM_MOVE = "crm_move",
    CRM_FIELD = "crm_field",
    WAIT = "wait",
  }

  export enum approver_roles {
    ADMIN = "admin",
    TUTOR = "tutor",
    BOTH = "both",
  }
}
